import "./_tooltips.scss";

import cx from "classnames";
import {ReactElement, useEffect, useState} from "react";

function Tooltips({
  tooltipMessage = "",
  isVisible = false,
  bottom = "auto",
  top = "auto",
  left = "auto",
  rigth = "auto",
}: {
  tooltipMessage?: string;
  isVisible: boolean;
  bottom?: number | string;
  top?: number | string;
  left?: number | string;
  rigth?: number | string;
}): ReactElement {
  const [startAnimationHide, setStartAnimationHide] =
    useState<boolean>(isVisible);

  useEffect(() => {
    if (isVisible && startAnimationHide) {
      setStartAnimationHide(false);
    }
    const animationTimeout = setTimeout((): void => {
      setStartAnimationHide(isVisible);
    }, 500);

    return () => {
      clearTimeout(animationTimeout);
    };
  }, [isVisible]);
  return (
    <div
      onMouseOver={event => {
        event.stopPropagation();
      }}
      className={cx(
        "tooltips",
        isVisible
          ? "tooltips-visibility"
          : startAnimationHide
            ? "tooltips-animationHide"
            : "hidden",
      )}
      style={{top: top, bottom: bottom, left: left, right: rigth}}>
      <p>{tooltipMessage}</p>
    </div>
  );
}

export default Tooltips;
